import { render } from "./InterfaceWysiwygElements.vue?vue&type=template&id=50102d35&scoped=true"
import script from "./InterfaceWysiwygElements.vue?vue&type=script&lang=js"
export * from "./InterfaceWysiwygElements.vue?vue&type=script&lang=js"

import "./InterfaceWysiwygElements.vue?vue&type=style&index=0&id=50102d35&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50102d35"]])

export default __exports__